import React, { useState } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Card,
	CardContent,
	Avatar,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Box,
	Typography,
	TextField,
	Button,
	IconButton,
} from "@mui/material";
import {
	Add as AddIcon,
	Close as CloseIcon,
	ExpandMore as ExpandMoreIcon,
	MoreVert as MoreVertIcon,
} from "@mui/icons-material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import instance from "../../apiServices/instance";
import moment from "moment";
import DOMPurify from "dompurify";
import DescriptionIcon from "@mui/icons-material/Description";
import { useParams } from "react-router-dom";

function NotesPage({ noteDetails, setCompanyInfo }) {
	const [boxData, setBoxData] = useState({
		title: "",
		content: "",
	});

	const { id } = useParams();
	const username = localStorage.getItem("username") || "";

	const handleSave = async () => {
		let requestPayload = {
			title: boxData.title,
			content: boxData.content,
			author: username,
		};
		const response = await instance.post(
			`/company-info/${id}/add-notes`,
			requestPayload
		);

		setCompanyInfo((prev) => ({
			...prev,
			noteDetails: response.data.data.notes,
		}));
		setOpenAddNoteDialog(false);
		// onClose();
	};
	const [openAddNoteDialog, setOpenAddNoteDialog] = useState(false);

	const handleOpenAddNoteDialog = () => {
		setOpenAddNoteDialog(true);
	};

	const handleCloseAddNoteDialog = () => {
		setOpenAddNoteDialog(false);
	};

	const formatDate = (dateString) => {
		const date = moment(dateString);
		const day = date.date();
		const monthYear = date.format("MMMM YYYY");

		// Convert day to ordinal format (1st, 2nd, 3rd, etc.)
		const ordinalDay =
			day +
			["th", "st", "nd", "rd"][
				day % 10 > 3 || Math.floor((day % 100) / 10) === 1
					? 0
					: day % 10
			];
		return { monthYear, formattedDate: `${ordinalDay} ${monthYear}` };
	};

	const transformNotes = (notes) => {
		const groupedNotes = {};

		notes.forEach((note) => {
			const { monthYear, formattedDate } = formatDate(note.createdAt);

			if (!groupedNotes[monthYear]) {
				groupedNotes[monthYear] = [];
			}

			groupedNotes[monthYear].push({
				id: note.id,
				title: note.title,
				content: note.content, // Remove HTML tags from content
				author: note.author,
				date: formattedDate,
			});
		});

		return groupedNotes;
	};

	const transformNotesData = transformNotes(noteDetails);

	return (
		<Box sx={{ p: 3 }}>
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					mb: 3,
				}}>
				<Typography variant='h6'>Notes</Typography>
				<Button
					variant='contained'
					startIcon={<AddIcon />}
					size='small'
					onClick={handleOpenAddNoteDialog}
					sx={{
						bgcolor: "#9161ff",
						borderRadius: 2,
						textTransform: "none",
					}}>
					Add Note
				</Button>
			</Box>

			{/* Notes by month */}
			{Object.entries(transformNotesData).map(([month, notes]) => (
				<Box key={month} sx={{ mb: 4 }}>
					<Typography variant='h6' sx={{ mb: 2, color: "#555" }}>
						{month}
					</Typography>

					{notes.map((note) => (
						<Card
							key={note.id}
							variant='outlined'
							sx={{
								mb: 2,
								borderRadius: 1,
								boxShadow: "none",
								border: "1px solid #e0e0e0",
							}}>
							<CardContent sx={{ p: 0 }}>
								<Accordion
									disableGutters
									elevation={0}
									sx={{
										"&:before": { display: "none" },
										borderBottom: "none",
									}}>
									<AccordionSummary
										expandIcon={<ExpandMoreIcon />}
										sx={{
											px: 2,
											py: 1,
											flexDirection: "row-reverse",
											"&.Mui-expanded": {
												borderBottom:
													"1px solid #f0f0f0",
											},
										}}>
										<Box
											sx={{
												display: "flex",
												alignItems: "center",
												width: "100%",
											}}>
											<Typography
												sx={{
													fontWeight: "bold",
													flexGrow: 1,
													ml: 1,
												}}>
												{note.title}
											</Typography>
											<IconButton
												size='small'
												sx={{ ml: "auto" }}>
												<MoreVertIcon fontSize='small' />
											</IconButton>
										</Box>
									</AccordionSummary>
									<AccordionDetails sx={{ p: 2, pt: 1 }}>
										<Typography
											variant='body2'
											sx={{ whiteSpace: "pre-line" }}
											dangerouslySetInnerHTML={{
												__html: DOMPurify.sanitize(
													note.content
												),
											}}
										/>
									</AccordionDetails>
								</Accordion>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										bgcolor: "#E6E6FA",
										p: 2,
										borderBottomLeftRadius: 4,
										borderBottomRightRadius: 4,
									}}>
									<Avatar
										sx={{
											width: 24,
											height: 24,
											bgcolor: "#9161ff",
											fontSize: "0.8rem",
											mr: 1,
											ml: 3,
											textTransform: "uppercase",
										}}>
										{username.charAt(0)}
									</Avatar>
									<Typography
										variant='body2'
										sx={{ fontWeight: "500" }}>
										{note.author}
									</Typography>
									<Typography
										variant='body2'
										sx={{
											ml: "auto",
											color: "black",
											fontWeight: 500,
										}}>
										{note.date}
									</Typography>
								</Box>
							</CardContent>
						</Card>
					))}
				</Box>
			))}

			{/* dialog box for add notes */}
			{/* <Dialog
        open={openAddNoteDialog}
        onClose={handleCloseAddNoteDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            bgcolor: "#f5f5f5",
            p: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant="h6"
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              Add Note
            </Typography>
          </Box>
          <IconButton
            aria-label="close"
            onClick={handleCloseAddNoteDialog}
            sx={{ ml: "auto" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
            Content
          </Typography>
          <TextField
            label="Title"
            variant="outlined"
            fullWidth
            size="small"
            sx={{ mb: 2 }}
            onChange={(e) => {
              setBoxData((prev) => ({
                ...prev,
                title: e.target.value,
              }));
            }}
            value={boxData.title}
          />
          <ReactQuill
            theme="snow"
            value={boxData.content}
            onChange={(e) => setBoxData((prev) => ({ ...prev, content: e }))}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2, justifyContent: "flex-end" }}>
          <Button
            onClick={handleCloseAddNoteDialog}
            variant="outlined"
            sx={{ borderRadius: 1, textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSave}
            sx={{
              bgcolor: "#5b19ff",
              borderRadius: 1,
              textTransform: "none",
              "&:hover": { bgcolor: "#4a14cc" },
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog> */}

			<Dialog
				open={openAddNoteDialog}
				onClose={handleCloseAddNoteDialog}
				fullWidth
				maxWidth='lg'
				sx={{ width: "100%", height: "100vh" }}>
				{/* Header */}
				<DialogTitle
					sx={{
						display: "flex",
						alignItems: "center",
						bgcolor: "#D9C2F2", // Light purple background
						p: 2,
						color: "black",
					}}>
					<DescriptionIcon sx={{ mr: 1 }} /> {/* File icon */}
					<Typography
						variant='h6'
						sx={{ flexGrow: 1, fontWeight: "bold" }}>
						Add Note
					</Typography>
					<IconButton
						aria-label='close'
						onClick={handleCloseAddNoteDialog}>
						<CloseIcon />
					</IconButton>
				</DialogTitle>

				{/* Content */}
				<DialogContent sx={{ p: 3 }}>
					<Typography
						variant='subtitle1'
						sx={{ fontWeight: "bold", mb: 1, mt: 2 }}>
						Content
					</Typography>

					{/* Title Field Styled as Table Row */}
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							border: "1px solid #ccc",
							borderRadius: "4px",
							mb: 0,
						}}>
						<Typography
							sx={{
								width: "120px",
								p: 1,
								borderRight: "1px solid #ccc",
								fontWeight: "bold",
								backgroundColor: "#f9f9f9",
							}}>
							Title
						</Typography>
						<TextField
							variant='standard'
							fullWidth
							InputProps={{ disableUnderline: true }}
							sx={{ p: 1 }}
							onChange={(e) =>
								setBoxData((prev) => ({
									...prev,
									title: e.target.value,
								}))
							}
							value={boxData.title}
						/>
					</Box>

					{/* Rich Text Editor (ReactQuill) */}
					<ReactQuill
						theme='snow'
						value={boxData.content}
						onChange={(e) =>
							setBoxData((prev) => ({ ...prev, content: e }))
						}
						style={{
							height: "250px",
							minHeight: "250px",
							maxHeight: "500px",
						}} // Adjust height to match image
					/>
				</DialogContent>

				{/* Actions */}
				<DialogActions
					sx={{
						p: 2,
						justifyContent: "flex-end",
						mb: 2,
						mt: 1,
						mr: 3,
					}}>
					<Button
						// onClick={onClose}
						variant='outlined'
						sx={{
							borderRadius: 2,
							textTransform: "none",
							width: "10%",
						}}>
						Cancel
					</Button>
					<Button
						variant='contained'
						onClick={handleSave}
						sx={{
							background: "#5b19ff",
							borderRadius: 2,
							textTransform: "none",
							width: "10%",
							"&:hover": { background: "#4a14cc" },
						}}>
						Save
					</Button>
				</DialogActions>
			</Dialog>
		</Box>
	);
}

export default NotesPage;
